module.exports = __webpack_public_path__ + "static/media/3.8c44dbb8.svg";